// Clicking or tabbing into any number box (carat, price, amount…) selects
// what's in it, so a new value types straight over the old one, like a
// spreadsheet cell. One listener for the whole app instead of an onFocus on
// every field. Selecting a moment later keeps the mouse release from
// clearing the selection again.

export function installSelectOnFocus() {
  document.addEventListener('focusin', e => {
    const el = e.target;
    if (!(el instanceof HTMLInputElement) || el.type !== 'number' || el.readOnly || el.disabled) return;
    setTimeout(() => {
      if (document.activeElement === el) {
        try { el.select(); } catch { /* not selectable */ }
      }
    }, 0);
  });
}
